class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();

    this.header = document.getElementById('shopify-section-header');
    this.headerWrapper = document.querySelector('.header-wrapper');
    this.main = document.querySelector('#MainContent');
  }

  onToggle() {
    if (!this.headerWrapper) return;
    this.headerWrapper.preventHide = this.mainDetailsToggle.open;

    if (this.mainDetailsToggle && this.main) {
      if (this.mainDetailsToggle.hasAttribute('open')) {
        this.main.classList.add('menu-opened');
        this.header.classList.add('menu-open');
      } else {
        this.main.classList.remove('menu-opened');
        this.header.classList.remove('menu-open');
      }
    }

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.headerWrapper.getBoundingClientRect().bottom)}px`);
  }
}

customElements.define('header-menu', HeaderMenu);


class HeaderSubmenu extends DetailsDisclosure {
  onFocusOut() {
    if (window.matchMedia("(min-width: 1200px)").matches) {
      super.onFocusOut();
    }
  }
}
customElements.define('header-submenu', HeaderSubmenu);
